import { discountTypesInversed } from '@teinor/erp/types/company/order/quote/quoteOrder/quoteOrderProduct'
import { RowData } from '../../../../types'
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { baseCalculateParams } from '@teinor/erp/prices/quote/calculate'

export const checkNewDiscountByFinalPrice = (allRowData: RowData, value: string) => {
    allRowData.discount = roundNumberAndDecimals(parseFloat(allRowData['rowPriceWithoutTaxAndTotalDiscount']) - parseFloat(value), baseCalculateParams)
    allRowData.typeDiscount = discountTypesInversed['quantity']
    return {discount: allRowData.discount, typeDiscount: allRowData.typeDiscount} 
}

export const checkNewDiscountByFinalPriceWithDiscountsWithVat = (allRowData: RowData, value: string) => {
    allRowData.discount = roundNumberAndDecimals(parseFloat(allRowData['rowPriceWithTaxAndTotalDiscount']) - parseFloat(value), baseCalculateParams)
    allRowData.typeDiscount = discountTypesInversed['quantity']
    return {discount: allRowData.discount, typeDiscount: allRowData.typeDiscount} 
}

export const checkNewDiscountByFinalPriceVat = (allRowData: RowData, value: string) => {
    const myPrice = parseFloat(value) * 100 / parseFloat(allRowData['rowPriceWithTaxAndTotalDiscount'])
    const percentageToDivide = myPrice / 100 
    const discountPreParsed = parseFloat(allRowData['rowPriceWithoutTaxAndTotalDiscount']) - (parseFloat(allRowData['rowPriceWithoutTaxAndTotalDiscount']) * percentageToDivide)
    allRowData.discount = roundNumberAndDecimals(discountPreParsed, baseCalculateParams) 
    allRowData.typeDiscount = discountTypesInversed['quantity']
    return {discount: allRowData.discount, typeDiscount: allRowData.typeDiscount} 
}